/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Slogan_2_Text_3Inputs */



/**
* | output |
* | --- |
* | "a paper trail" |
*
* @param {Auth_Slogan_2_Text_3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_slogan_2_text_3 = /** @type {((inputs?: Auth_Slogan_2_Text_3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Slogan_2_Text_3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Prüfpfad")
	return /** @type {LocalizedString} */ ("a paper trail")
});